import React from 'react'
import styles from './VideoControlButton.module.css'

type VideoControlButtonProps = {
  icon: React.JSX.Element
  onClick: () => void
  ariaLabel?: string
  testId?: string
  styleClasses?: string
}

const VideoControlButton: React.FC<VideoControlButtonProps> = ({ icon, onClick, styleClasses, ariaLabel, testId }) => {
  return (
    <div
      aria-label={ariaLabel}
      data-testid={testId}
      role='button'
      onClick={onClick}
      className={`${styles.videoControlButton} ${styleClasses || ''} cursor-pointer border-radius-rounded padding-top-s font-center`}
    >
      {icon}
    </div>
  )
}

export default VideoControlButton
